var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPortfolio = function SvgPortfolio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    d: "M19.6 3.5H4.4c-1.048 0-1.9.847-1.9 1.889V18.61c0 1.042.852 1.889 1.9 1.889h15.2c1.048 0 1.9-.847 1.9-1.889V5.39a1.896 1.896 0 0 0-1.9-1.889zM4.4 18.611V7.278h15.2l.002 11.333H4.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    d: "m9.428 9.443-3.521 3.501 3.521 3.501 1.344-1.335-2.179-2.166 2.179-2.165-1.344-1.336zm5.144 0-1.344 1.336 2.179 2.165-2.179 2.166 1.344 1.335 3.521-3.5-3.521-3.502z"
  })));
};
export default SvgPortfolio;